import { Hyphenator } from './hyphenation';
import { CzechHybridHyphenator } from './czech-hyphenator';
import csCZPatterns from './hyphenation/cs_CZ.json';
import enUSPatterns from './hyphenation/en_US.json';

const PATTERNS: Record<string, string[]> = {
  cs_CZ: csCZPatterns,
  en_US: enUSPatterns,
};

const hyphenators = new Map<string, Hyphenator>();

export function loadPatterns(language: string): string[] {
  const normalized = normalizeLanguage(language);
  return PATTERNS[normalized] || [];
}

export function getHyphenator(language: string): Hyphenator {
  const normalized = normalizeLanguage(language);

  let hyphenator = hyphenators.get(normalized);

  if (!hyphenator) {
    const patterns = loadPatterns(normalized);
    hyphenator =
      normalized === 'cs_CZ'
        ? new CzechHybridHyphenator(normalized, patterns)
        : new Hyphenator(normalized, patterns);
    hyphenators.set(normalized, hyphenator);
  }

  return hyphenator;
}

function normalizeLanguage(language: string): string {
  const lower = language.toLowerCase();

  if (lower === 'cs' || lower === 'cs_cz' || lower === 'czech') {
    return 'cs_CZ';
  }
  if (lower === 'en' || lower === 'en_us' || lower === 'english') {
    return 'en_US';
  }

  return language;
}

export function hyphenate(word: string, language = 'en'): string[] {
  return getHyphenator(language).hyphenate(word);
}

export function createLanguageHyphenator(language: string): Hyphenator {
  return getHyphenator(language);
}
